var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonAddDisabled = function SvgButtonAddDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 3.99994C12.9599 3.99994 3.99988 12.9599 3.99988 23.9999C3.99988 35.0399 12.9599 43.9999 23.9999 43.9999C35.0399 43.9999 43.9999 35.0399 43.9999 23.9999C43.9999 12.9599 35.0399 3.99994 23.9999 3.99994ZM31.9999 25.9999H25.9999V31.9999C25.9999 33.0999 25.0999 33.9999 23.9999 33.9999C22.8999 33.9999 21.9999 33.0999 21.9999 31.9999V25.9999H15.9999C14.8999 25.9999 13.9999 25.0999 13.9999 23.9999C13.9999 22.8999 14.8999 21.9999 15.9999 21.9999H21.9999V15.9999C21.9999 14.8999 22.8999 13.9999 23.9999 13.9999C25.0999 13.9999 25.9999 14.8999 25.9999 15.9999V21.9999H31.9999C33.0999 21.9999 33.9999 22.8999 33.9999 23.9999C33.9999 25.0999 33.0999 25.9999 31.9999 25.9999Z",
    fill: "#C4C4C4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonAddDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ButtonAddDisabled.8590e59a.svg";
export { ForwardRef as ReactComponent };